/* global
  TRANSLOC_STRIPE_PUB_KEY,
  TOKEN_TRANSIT_STRIPE_PUB_KEY,
*/

import _ from 'underscore';

import {omitNull} from 'common/utils';

export const paymentProviders = {
  STRIPE: 'stripe',
  TOKEN_TRANSIT: 'token_transit',
};

export default class AgencySettings {
  /* eslint-disable camelcase */
  constructor({
    timezone,
    latitude,
    longitude,
    service_message,
    fare_payment_enabled,
    stripe_connected,
    token_transit_connected,
    token_transit_account_id,
    email,
    phone,
  }) {
    this.agency_setting_id = 1;
    this.timezone = timezone || '';
    this.latitude = latitude || null;
    this.longitude = longitude || null;
    this.service_message = service_message || '';
    this.stripe_connected = !!stripe_connected;
    this.token_transit_connected = !!token_transit_connected;
    this.fare_payment_enabled = !!fare_payment_enabled;
    this.email = email || null;
    this.phone = phone || null;

    // This account ID is only available users with a view agency permission
    this.token_transit_account_id = token_transit_account_id || '';
  }
  /* eslint-enable camelcase */

  clone() {
    return new AgencySettings(this.serialize());
  }

  serialize() {
    return omitNull({
      timezone: this.timezone,
      latitude: this.latitude,
      longitude: this.longitude,
      service_message: this.service_message,
      fare_payment_enabled: this.fare_payment_enabled,
      stripe_connected: this.stripe_connected,
      token_transit_connected: this.token_transit_connected,
      token_transit_account_id: this.token_transit_account_id,
      email: this.email,
      phone: this.phone,
    });
  }

  isDifferent(other, omit) {
    return other && other.serialize ? !_.isEqual(
      _.omit(this.serialize(), omit),
      _.omit(other.serialize(), omit),
    ) : true;
  }

  // Returns the correct stripe publishable key corresponding to the payment provider
  // an agency has configured
  get stripePublishableKey() {
    if (this.stripe_connected) {
      return TRANSLOC_STRIPE_PUB_KEY;
    } else if (this.token_transit_connected) {
      return TOKEN_TRANSIT_STRIPE_PUB_KEY;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/common/types/AgencySettings.js